import { Button, Dialog, Divider,ListItem, ListItemText, ListItemAvatar,  TextField,Select,MenuItem,Avatar } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import ActionsContextV2 from "../ActionsContextV2";
import ActionCommentHistroryV2 from "../actionsFormV2/ActionCommentHistoryV2";

const TextFieldContainer = styled.div`
  width: 100%;
`;


const TitleContainer = styled.div`
width:100%;
color: white;
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
padding:20px;
height:80px;
background-color:RGB(48, 74, 87);
display:flex;
align-items:center;
`

const ContentContainer = styled.div`
  padding-left:20px;
  padding-right:20px;
  overflow-y:auto;
  padding-top:10px;
  min-height:250px;

`

const ButtonsContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:flex-end;
height:80px;
padding-right:20px;
`

const ButtonContainer = styled.div`
width:100px;
padding-left:20px;
`

const Container = styled.div`

width:760px;
display:flex;
flex-direction:column;
align-items:space-between;
 
`;

const CommentsLabel = styled.div`

  padding-top:10px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
 
`;

const ReturnToLabel = styled.div`

  padding-top:10px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  padding-bottom:10px;

`;

const ReturnToContainer = styled.div`

  width:50%;
  padding-bottom:15px;
`;

class ActionCommentsDialogV2 extends React.Component {
  constructor(props)
  {
      super(props);

      let {workflowSteps = [] } = this.props.context.commentsAction;
      workflowSteps = workflowSteps.slice(0,props.context.commentsAction.currentStepIndex)

      this.state = {
        workflowSteps,
        comments : props.context.commentsAction.comments,
        statusActionReturnToIndex : workflowSteps.length === 1 ? 0 : props.context.commentsAction.statusActionReturnToIndex,
        showSelect: workflowSteps.length !== 1,
        procedureComments : props.context.commentsAction.procedureComments,
        newProcedureComment:'',
      }
  }

  renderReturnTo()
  {
    if (!this.props.context.commentsClearStatusActionOnCancel) {
      return null;
    }

    return (
      <ReturnToContainer>
    
              <ReturnToLabel>
              {this.state.showSelect ? "Return To*" : "Return To"}
              </ReturnToLabel>
          {this.state.showSelect ?
              
          <Select
                        value={this.state.statusActionReturnToIndex}
                        fullWidth
                        variant="outlined"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={(event) => {
                          this.setState({statusActionReturnToIndex:event.target.value});
                       
                        }}
                        >
                        {this.state.workflowSteps.map( (workflowStep,index) => <MenuItem key={index} value={index}>
                          <ListItem>
                            <ListItemAvatar>
                              <Avatar src={`/api/users/userImage?bun=${workflowStep.assigneeBun}`}/>
                            </ListItemAvatar>
                            <ListItemText primary={workflowStep.label} secondary={workflowStep.assignee} />
                          </ListItem>
                          </MenuItem>)}

                        </Select>
                :
                <ListItem>
                <ListItemAvatar>
                  <Avatar src={`/api/users/userImage?bun=${this.state.workflowSteps[0].assigneeBun}`}/>
                </ListItemAvatar>
                <ListItemText primary={this.state.workflowSteps[0].label} secondary={this.state.workflowSteps[0].assignee} />
              </ListItem>
            } 
      </ReturnToContainer>
    )
  }

  render() {

    const {commentsClearStatusActionOnCancel,commentsDialogOpen,updateAction,closeComments,saveActionProcedureComment} = this.props.context; 

    const title = commentsClearStatusActionOnCancel ? "Return Procedure" : "Comments";

    let sortedProcedureComments = this.state.procedureComments.sort((a, b) => Date.parse(new Date(a.dateAdded.split("/").reverse().join("-"))) - Date.parse(new Date(b.dateAdded.split("/").reverse().join("-"))));

    return (
      <Dialog maxWidth='xl' open={commentsDialogOpen}>
        <Container>
        <TitleContainer><div>{title}</div></TitleContainer>

        <ContentContainer style={{maxHeight:window.innerHeight - 300,height:commentsClearStatusActionOnCancel ? window.innerHeight - 300 : undefined}}>
        {this.props.context.commentsEditable ?
          <>
          {this.renderReturnTo()}

          {/* <CommentsLabel>Comments*</CommentsLabel> */}

          {this.props.context.commentsAction.procedureComments &&
            sortedProcedureComments.map((procedureComment, index) => (
              <ActionCommentHistroryV2 procedureComment={procedureComment} index={index} />
            ))
          }

         <TextFieldContainer>
            <TextField placeholder="Start Typing..." onChange={event => {
              this.setState({comments:event.target.value});
              this.setState({newProcedureComment:{pmprocedureId:this.props.context.commentsAction.procedureId, comment:event.target.value, addedByBun:this.props.context.aboutCurrentUser.bun}});
            }}
             multiline fullWidth margin="normal" variant="outlined" />
          </TextFieldContainer>
          </>
          :
          <TextFieldContainer>
            {/* {this.state.comments} */}
            {this.props.context.commentsAction.procedureComments &&
              sortedProcedureComments.map((procedureComment, index) => (
                <ActionCommentHistroryV2 procedureComment={procedureComment} index={index} />
              ))
            }
          </TextFieldContainer>

        }

        </ContentContainer>
        <Divider/>
        <ButtonsContainer>
         <ButtonContainer>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {

              if(commentsClearStatusActionOnCancel) {

                updateAction(this.props.context.commentsAction,{comments:this.state.comments,statusAction:null,statusActionReturnToIndex:null});

              }
              closeComments();
            }}
          >
          {this.props.context.commentsEditable ? 'Cancel' : 'Close'}
          </Button>
          </ButtonContainer>

          {this.props.context.commentsEditable ?
          <ButtonContainer>
          <Button
            variant="outlined"
            color="primary"
            disabled={!this.state.comments}
            onClick={() => {
                updateAction(this.props.context.commentsAction,{comments:this.state.comments,statusActionReturnToIndex:this.state.statusActionReturnToIndex});
                saveActionProcedureComment(this.state.newProcedureComment);
                closeComments();
              }}
            >Save</Button></ButtonContainer>
            : <></>
          }
        </ButtonsContainer>
        </Container>
      </Dialog>
    );
  }
}

export default ActionCommentsDialogV2;
